import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PlusCircle,
  RefreshCw,
  RotateCcw,
  ChevronUp,
} from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { deleteWareHouse,
     getWareHouseByGuid,
      getWareHouseList } from "../../services/MasterApiServices";
import WareHouseModal from "../../components/master/modal/WareHouseModal";
import withReactContent from "sweetalert2-react-content";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../redux/toggle";
import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../redux/helper";
import { exportMasterExcel, exportMasterPDF, printMasterReport } from "../../core/utils/MasterReportUtils";

const WareHouse = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [warehouseData, setwarehouseData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const { togglehead } = useSelector((state) => state.headerToggle);
  const {menuItems} = useSelector((state) => state.amc);
    const { branch } = useSelector((state) => state.branchlist);
  const [permit, setpermit] = useState();
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };

  // useEffect(() => {
  //   handleWareHouseList();
  //    console.log(menuItems?.menuPermissions?.map(e => e.menu.name)); 
  //   setpermit(menuItems?.menuPermissions?.find(e=> e.menu.name =="Ware House"));
  // }, []);

  useEffect(() => {
  handleWareHouseList();
  if (menuItems?.menuPermissions) {
    setpermit(menuItems.menuPermissions.find(e => e.menu.name === "Ware House"));
  }
}, [menuItems, branch]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const modifiedList = Array.isArray(warehouseData)
    ? warehouseData?.filter((value) =>
        value.name?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];
  const handleWareHouseList = async () => {
    try {
      const response = await getWareHouseList();
      console.log("WareHouse List", response);

      if (Array.isArray(response)) {
            // Filter by currentBranchID
      const filtered = response.filter(
        (wh) => wh.branchID === branch?.guid
      );
      setwarehouseData(filtered);
      } else {
        setwarehouseData([]); // If response is not an array, reset to an empty array
      }
    } catch (error) {
      console.log(error?.response?.data?.Message || "something went wrong");
      setwarehouseData([]);
    }
  };
  const handleEditClick = async (guid) => {
    try {
      const response = await getWareHouseByGuid(guid);
      setUpdateData(response); // Set the data for editing
      setModalMode("edit"); // Set the modal mode to 'edit'
      setModalOpen(true); // Open the modal
    } catch (error) {
      console.error(
        "Error fetching WareHouse by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  // const handleDeleteClick = (id) => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     cancelButtonColor: "#ff0000",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "Cancel",
  //   }).then(async (result) => {
  //     console.log(result);
  //     if (result.isConfirmed) {
  //       try {
  //         const response = await deleteWareHouse(id);
  //         if (response) {
  //           MySwal.fire({
  //             title: "Deleted!",
  //             text: "The WareHouse has been deleted.",
  //             icon: "success",
  //             confirmButtonColor: "#00ff00",
  //             confirmButtonText: "OK",
  //           }).then(() => {
  //             handleWareHouseList(); // Refresh the list
  //             // setSearchText(""); // Clear the search text
  //           });
  //         } else {
  //           MySwal.fire({
  //             title: "Error!",
  //             text: "Something went wrong.",
  //             icon: "error",
  //             confirmButtonColor: "#ff0000",
  //             confirmButtonText: "OK",
  //           });
  //         }
  //       } catch (error) {
  //         console.error(
  //           "Error deleting Reasontype:",
  //           error?.response?.data?.Message || "something went wrong"
  //         );
  //         MySwal.fire({
  //           title: "Error!",
  //           text: error?.response?.data?.Message || "something went wrong",
  //           icon: "error",
  //           confirmButtonColor: "#ff0000",
  //           confirmButtonText: "OK",
  //         });
  //       }
  //     }
  //   });
  // };


// const handleDeleteClick = (id) => {
//   MySwal.fire({
//     title: "Are you sure?",
//     text: "You won't be able to revert this!",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#00ff00",
//     cancelButtonColor: "#ff0000",
//     confirmButtonText: "Yes, delete it!",
//     cancelButtonText: "Cancel",
//   }).then(async (result) => {
//     if (result.isConfirmed) {
//       try {
//         const response = await deleteWareHouse(id);
//         if (response) {
//           MySwal.fire({
//             title: "Deleted!",
//             text: "The WareHouse has been deleted.",
//             icon: "success",
//             confirmButtonColor: "#00ff00",
//             confirmButtonText: "OK",
//           }).then(() => {
//             handleWareHouseList(); // refresh the table
//           });
//         } else {
//           MySwal.fire({
//             title: "Error!",
//             text: "Something went wrong while deleting.",
//             icon: "error",
//             confirmButtonColor: "#ff0000",
//             confirmButtonText: "OK",
//           });
//         }
//       } catch (error) {
//         console.error("Delete Error:", error?.response?.data || error);
//         MySwal.fire({
//           title: "Error!",
//           text: error?.response?.data?.Message || "Something went wrong.",
//           icon: "error",
//           confirmButtonColor: "#ff0000",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   });
// };
const handleDeleteClick = (guid) => {
  MySwal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#00ff00",
    cancelButtonColor: "#ff0000",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await deleteWareHouse(guid);
        if (response) {
          MySwal.fire({
            title: "Deleted!",
            text: "The WareHouse has been deleted.",
            icon: "success",
            confirmButtonColor: "#00ff00",
            confirmButtonText: "OK",
          }).then(() => handleWareHouseList());
        } else {
          MySwal.fire({
            title: "Error!",
            text: "Something went wrong while deleting.",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error("Delete Error:", error?.response?.data || error);
        MySwal.fire({
          title: "Error!",
          text: error?.response?.data?.Message || "Something went wrong.",
          icon: "error",
          confirmButtonColor: "#ff0000",
          confirmButtonText: "OK",
        });
      }
    }
  });
};


  const columns = [
    {title:"Code",
    dataIndex:"code"
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.Name?.length - b.Name?.length,
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title:"Vehicle No",
      dataIndex:"vehicleNo"
    },
    ...(permit?.edit || permit?.deletion
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, obj) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {permit?.edit && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      onClick={() => handleEditClick(obj.guid)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permit?.deletion && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => handleDeleteClick(obj.guid)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : [])
  ];

  const MySwal = withReactContent(Swal);
  const getActiveTabData = () => {
    let fieldMapping = {};
  
    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };
  
    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);
    
    // Return the filtered data, columns, and field mapping
    return { data: modifiedList, columns: columns, fieldMapping , Rname:"Ware House"};
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Ware House</h4>
                <h6>Manage Ware House here</h6>
              </div>
            </div>
            <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                <Link onClick={() => exportMasterPDF(getActiveTabData,"Ware House")}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                <Link
                  onClick={() => exportMasterExcel(getActiveTabData,"Ware House")}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                <Link
                 onClick={() => printMasterReport(getActiveTabData,"Ware House")}
                >
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handleWareHouseList()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <ul className="table-top-head"></ul>
            <div className="d-flex purchase-pg-btn">
            {permit?.add && 
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                onClick={() => {
                  setModalMode("add"); // Set the modal mode to 'add'
                  setModalOpen(true); // Open the modal
                }}
              >
                <PlusCircle className="me-2" />
                New
              </Link>
            </div>}
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top mb-2">
               <div className="search-set">
        <div className="search-input">
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <div className="input-group input-group-sm">
              <span className="input-group-text bg-white border-end-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-search"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
              <input
                type="search"
                className="form-control border-start-0"
                placeholder="Search"
                value={searchText}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
              </div>
              {/* /Filter */}

              {/* /Filter */}
              <div className="table-responsive product-list">
                <Table columns={columns} dataSource={modifiedList} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

      {modalOpen && (
        <WareHouseModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handleWareHouseList(); // Refresh the list
            // Clear the search text
          }}
        />
      )}
    </div>
  );
};

export default WareHouse;
